import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { OtherInputField } from "@lib/config/form";
import { type Emirate, areEmirates, normaliseLocations } from "@lib/uae";
import { cn } from "@lib/utils";
import { useFormContext } from "react-hook-form";

type DistrictProps = OtherInputField & {
  language: string;
};

export function District({ language, label, placeholder }: DistrictProps) {
  const { control, setValue } = useFormContext();

  const emirates = normaliseLocations(areEmirates, language as "en" | "ar");

  return (
    <FormField
      control={control}
      name="district"
      render={({ field }) => (
        <FormItem>
          <FormLabel
            className="mb-[0.875rem] block"
            id="district-label"
            style={{
              fontSize: "var(--label-font-size)",
              fontFamily: "var(--label-font-name, var(--font-family))",
              fontStyle: "var(--label-font-style, var(--font-style))",
              fontWeight: "var(--label-font-weight, var(--font-weight))",
              color: "var(--label-color)",
            }}
          >
            {label}
          </FormLabel>
          <Select
            onValueChange={(value: Emirate) => {
              field.onChange(value);
              setValue("town", undefined);
            }}
          >
            <FormControl>
              <SelectTrigger
                aria-labelledby="district-label"
                className={cn(!field.value && "text-[--placeholder-color]")}
              >
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {emirates.map(({ value, label }) => (
                <SelectItem key={value} value={value}>
                  {label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
